import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input, FormGroup, Label, Form, Row, Col, Card, CardBody, InputGroup, InputGroupText } from "reactstrap";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { useAuth } from "../../Context/AuthenticateProvider"; // Machan token data-ku idhu venum
import { getCookie } from "../../Helpers/Utils";

const AddExpense = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = getCookie("user_data") ? JSON.parse(getCookie("user_data")) : {};
  // const { user } = useAuth(); 

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '45px',
      height: '45px',
      borderRadius: '8px',
      borderColor: state.isFocused ? '#2e4a3d' : '#dee2e6',
      boxShadow: state.isFocused ? '0 0 0 0.1rem rgba(46, 74, 61, 0.25)' : 'none',
      '&:hover': { borderColor: '#2e4a3d' }
    }),
    valueContainer: (provided) => ({ ...provided, height: '45px', padding: '0 12px' }),
    input: (provided) => ({ ...provided, margin: '0px' }),
    indicatorSeparator: () => ({ display: 'none' }),
    indicatorsContainer: (provided) => ({ ...provided, height: '45px' }),
    menuPortal: base => ({ ...base, zIndex: 9999 })
  };

  // Form States
  const [formData, setFormData] = useState({
    staff_id: "", // Admin select panna idhu fill aagum
    type: "expense",
    amount: "",
    description: ""
  });

  const [staffOptions, setStaffOptions] = useState([]);
  const [availableBalance, setAvailableBalance] = useState(0);
  const [errors, setErrors] = useState({});

  const typeOptions = [
    { value: "expense", label: "General Expense" },
    { value: "investment", label: "Investment" }
  ];

  useEffect(() => {
    if (!user?.id || !user?.role) return;

    if (user.role === 'admin') {
      const getStaffs = async () => {
        try {
          const res = await Handler({ method: "GET", url: "/staff/list.php" });
          if (res?.success) {
            setStaffOptions(res.data.map(s => ({ value: s.id, label: s.name?.toUpperCase() })));
            dispatch(loadingFalse());
          }
        } catch (err) { toast.error("Error loading staff list"); }
      };
      getStaffs();
    } else {
      setFormData(prev => {
        if (prev.staff_id === user.id) return prev;
        return { ...prev, staff_id: user.id };
      });
    }

  }, [user?.id, user?.role]);

  // 2. Fetch Balance whenever staff_id changes
  useEffect(() => {
    if (formData.staff_id) {
      const fetchBalance = async () => {
        try {
          const res = await Handler({
            method: "GET",
            url: `/deposit/balance.php?staff_id=${formData.staff_id}`
          });
          if (res?.success) {
            setAvailableBalance(res.data.summary.balance);
            dispatch(loadingFalse());
          } else {
            dispatch(loadingFalse());
          }
        } catch (err) { console.error("Balance fetch error"); }
      };
      fetchBalance();
    } else {
      setAvailableBalance(0);
    }
  }, [formData.staff_id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.staff_id) return toast.error("Please select a staff member");

    if (parseFloat(formData.amount) > availableBalance) {
      return Swal.fire("Insufficient Balance", `Available balance is ₹${availableBalance?.toLocaleString()}`, "warning");
    }

    dispatch(loadingTrue());
    try {
      const res = await Handler({
        method: "POST",
        url: "/expense/create.php",
        data: formData
      });
      console.log("API Response:", res);

      if (res?.success) {
        Swal.fire("Success!", "Expense recorded successfully", "success");
        navigate("/expenses");
        dispatch(loadingFalse());
      } else {
        if (res?.errors) setErrors(res.errors);
        else toast.error(res?.message || "Failed to record expense");
        dispatch(loadingFalse());
      }
    } catch (err) {
      Swal.fire("Error", "Server error occurred", "error");
    } finally {
      dispatch(loadingFalse());
    }
  };

  return (
    <div className="page-container p-1">
      <div className="page-header mb-4">
        <h6 className="text-muted">Finance &gt; Expenses</h6>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h3 className="fw-bold">New Expense Entry</h3>
            <p className="text-muted">Record daily mill expenses or investments.</p>
          </div>
          <Button color="secondary" outline onClick={() => navigate(-1)}>
            <i className="bx bx-arrow-back"></i> Back
          </Button>
        </div>
      </div>

      <Row>
        <Col lg={8}>
          <Card className="border-0 shadow-sm" style={{ borderRadius: '15px' }}>
            <CardBody className="p-4">
              <Form onSubmit={handleSubmit}>
                <Row>
                  {/* ADMIN-KU MATTUM STAFF SELECTOR KAATUM */}
                  {user?.role === 'admin' && (
                    <Col md={12} className="mb-3">
                      <FormGroup>
                        <Label>Select Staff Member</Label>
                        <Select
                          options={staffOptions}
                          styles={customSelectStyles}
                          placeholder="Search & Select Staff..."
                          onChange={(opt) => setFormData({ ...formData, staff_id: opt ? opt.value : "" })}
                        />
                      </FormGroup>
                    </Col>
                  )}

                  <Col md={6}>
                    <FormGroup>
                      <Label>Expense Type</Label>
                      <Select
                        options={typeOptions}
                        styles={customSelectStyles}
                        defaultValue={typeOptions[0]}
                        onChange={(opt) => setFormData({ ...formData, type: opt.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Amount</Label>
                      <InputGroup>
                        <InputGroupText className="bg-light">₹</InputGroupText>
                        <Input
                          type="number"
                          name="amount"
                          placeholder="0.00"
                          className={errors.amount ? "is-invalid" : ""}
                          value={formData.amount}
                          onChange={handleChange}
                          required
                        />
                      </InputGroup>
                      {errors.amount && <div className="text-danger small mt-1">{errors.amount}</div>}
                    </FormGroup>
                  </Col>
                </Row>

                <FormGroup className="mt-3">
                  <Label>Description / Remarks</Label>
                  <Input
                    type="textarea"
                    name="description"
                    placeholder="Enter details..."
                    rows="4"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </FormGroup>

                <div className="mt-4 pt-3 border-top d-flex justify-content-end">
                  <Button type="submit" className="add-btn px-5">
                    <i className="bx bx-check-double me-1"></i> Record Expense
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>

        <Col lg={4}>
          <Card className="border-0 shadow-sm bg-theme text-white" style={{ borderRadius: '15px' }}>
            <CardBody className="p-4 text-center">
              <i className="bx bx-wallet fs-1 mb-2 opacity-50"></i>
              <h6 className="opacity-75">
                {user?.role === 'admin' ? "Staff's Wallet Balance" : "My Wallet Balance"}
              </h6>
              <h2 className="fw-bold mt-2">₹ {availableBalance.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</h2>
              <p className="small mt-3 mb-0 opacity-75">
                {formData.staff_id ? "Expense limit for the selected account." : "Please select a staff member."}
              </p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AddExpense;